// Thin wrapper over the Google tag defined inline in index.html. Events are queued in
// dataLayer and only become cookies/hits according to the visitor's cookie choice, which is
// made in the WorkBrawl hub and read by that inline snippet (Consent Mode).
//
// The same event names are used by every WorkBrawl title, so they can be compared:
// room_created, room_joined_by_code, round_started, round_finished. Never send personal
// data (names, ids, room codes).

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function track(event: string, params: Record<string, string | number> = {}): void {
  try {
    window.gtag?.("event", event, params);
  } catch {
    // Analytics must never break the app.
  }
}
